export default __webpack_public_path__ + "3cdfe3b57964d3b2ca3be46ee6575832.png";